// Procedures load more button logic
import { clickOn } from "../../events/click";
import { load } from "../../events/load";

const initProceduresLoadMore = () => {
    const proceduresSection = document.querySelector('.direction-content__procedures');
    if (!proceduresSection) return;

    const proceduresList = proceduresSection.querySelector('.direction-content__procedures-list');
    const loadMoreBtn = proceduresSection.querySelector('[data-procedures-load-more]');

    if (!loadMoreBtn || !proceduresList) return;

    const i18n = window.params?.i18n || {};
    const TEXT_EXPAND = i18n.btn_view_more || 'View more';
    const TEXT_COLLAPSE = i18n.text_collapse || 'Collapse';
    const TEXT_LOADING = i18n.loading || 'Loading...';

    let isExpanded = false;

    clickOn('[data-procedures-load-more]', async (event, trigger) => {
        event.preventDefault();

        const btnText = trigger.querySelector('.btn__text');

        // Show loading state
        if (btnText) {
            btnText.textContent = TEXT_LOADING;
        }
        trigger.disabled = true;

        // Short delay for UX feedback
        await new Promise(resolve => setTimeout(resolve, 300));

        if (isExpanded) {
            // Collapse
            proceduresList.classList.remove('direction-content__procedures-list--expanded');
            if (btnText) {
                btnText.textContent = TEXT_EXPAND;
            }
            // Scroll to procedures section
            proceduresSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            // Expand
            proceduresList.classList.add('direction-content__procedures-list--expanded');
            if (btnText) {
                btnText.textContent = TEXT_COLLAPSE;
            }
        }

        isExpanded = !isExpanded;
        trigger.disabled = false;
    });
};

load(initProceduresLoadMore);

